import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnChanges, SimpleChanges, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { ProductContextDirective } from 'ish-core/directives/product-context.directive';
import { LineItemView } from 'ish-core/models/line-item/line-item.model';
import { OrderLineItem } from 'ish-core/models/order/order.model';
import { Price } from 'ish-core/models/price/price.model';
import { PricePipe } from 'ish-core/models/price/price.pipe';
import { PagingComponent } from 'ish-shared/components/common/paging/paging.component';
import { CustomCheckoutLineItemElementComponent } from 'ish-shared/dias/components/line-item/custom-checkout-line-item-element/custom-checkout-line-item-element.component';

@Component({
  selector: 'custom-checkout-line-item-list',
  templateUrl: './custom-checkout-line-item-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgClass,
    CustomCheckoutLineItemElementComponent,
    ProductContextDirective,
    PagingComponent,
    PricePipe,
    TranslateModule,
  ],
})
export class CustomCheckoutLineItemListComponent implements OnChanges {
  readonly lineItems = input<Partial<LineItemView & OrderLineItem>[]>(undefined);
  readonly editable = input(true);
  readonly total = input<Price>(undefined);
  readonly lineItemViewType = input<'simple' | 'availability'>(undefined);
  /**
   * If pageSize > 0 only <pageSize> items are shown at once and a paging bar is shown below the line item list.
   */
  readonly pageSize = input(25);

  currentPage = 1;
  lastPage: number;
  displayItems: Partial<LineItemView & OrderLineItem>[] = [];

  ngOnChanges(c: SimpleChanges) {
    if (c.lineItems) {
      this.lastPage = Math.ceil(this.lineItems()?.length / this.pageSize());
      this.goToPage(this.currentPage);
    }
  }

  get showPagingBar() {
    const pageSize = this.pageSize();
    return pageSize && this.lineItems()?.length > pageSize;
  }

  trackByFn(_: number, item: Partial<LineItemView & OrderLineItem>) {
    return item.productSKU;
  }

  /**
   * Refresh items to display after changing the current page
   *
   * @param page current page
   */
  goToPage(page: number) {
    this.currentPage = page;

    const pageSize = this.pageSize();
    this.displayItems = pageSize ? this.lineItems().slice((page - 1) * pageSize, page * pageSize) : this.lineItems();
  }
}
